const SSO = () => <sso />;
export default SSO;